import { useCallback } from 'react';
import { RichEditor } from '@odo/shared-ui';
import { uploadInternalImage } from '../../../../../services/internalImages';
import type { RichEditorPreset, TiptapDoc } from '@odo/shared-ui';

interface VcaNotesStepProps {
    patientId: string;
    value: TiptapDoc;
    onChange: (doc: TiptapDoc) => void;
    /** Offered as "Start from a preset" cards while the notes are empty. */
    presets?: RichEditorPreset[];
}

function VcaNotesStep({ patientId, value, onChange, presets }: VcaNotesStepProps) {
    const handleImageUpload = useCallback(
        async (file: File) => {
            const result = await uploadInternalImage(patientId, file, 'vca');
            return { url: result.url, fileId: result.fileId };
        },
        [patientId]
    );

    return (
        <div className="flex-1 min-h-0 flex flex-col">
            <RichEditor
                value={value}
                onChange={onChange}
                onImageUpload={handleImageUpload}
                placeholder="Add notes…"
                chrome="flush"
                presets={presets}
            />
        </div>
    );
}

export { VcaNotesStep };
